module.exports = __webpack_public_path__ + "img/Login-carousal-2.a8766700.svg";